import { render, staticRenderFns } from "./merge-pay-records.vue?vue&type=template&id=6703cab2&"
import script from "./merge-pay-records.vue?vue&type=script&lang=js&"
export * from "./merge-pay-records.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports